import styled from 'styled-components';
import { NotificationContainer } from '../NotificationContainer';

const StyledContainer = styled.div`
	position: absolute;
	bottom: 40px;
	right: 40px;
	z-index: 500;
`;

const StyledNotificationContainer = styled(NotificationContainer)`
	left: inherit;
	right: 0;
	bottom: 0;
	background-color: #2d70da;

	transform: translate(0, 0);

	&.fade-enter {
		opacity: 0;
		transform: translate(0, -80px);
	}

	&.fade-enter-active,
	&.fade-enter-done,
	&.fade-exit {
		opacity: 1;
		transform: translate(0, 0);
	}

	&.fade-exit-active {
		opacity: 0;
		transform: translate(0, 80px);
	}
`;

const StyledCountContainer = styled.div`
	position: relative;
	bottom: 60px;

	& > div {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		gap: 10px;
	}
`;

const StyledCountNotification = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	height: 30px;
	padding: 0 10px;
	background-color: #ffffff;
	border-radius: 10px;
	transform: translate(0, 200%);
	opacity: 0;
	transition:
		transform 0.3s ease,
		opacity 0.3s ease;

	&.notification-enter {
		opacity: 0;
		transform: translate(0, 200%);
	}

	&.notification-enter-active,
	&.notification-enter-done,
	&.notification-exit {
		opacity: 1;
		transform: translate(0, 0);
	}

	&.notification-exit-active {
		opacity: 0;
		transform: translate(0, -200%);
	}

	img {
		width: 14px;
		height: 14px;
		filter: invert(100%);
		user-select: none;
		pointer-events: none;
	}
`;

export {
	StyledContainer,
	StyledCountContainer,
	StyledCountNotification,
	StyledNotificationContainer,
};
